import produce from "immer";
import { LoadState } from "../../constants/enums";
import { IAgentDashboardInformationState } from "./agentDashboard.types";
import { defaultAgentDashbaordInfoState } from "./agentDashboard.state";
import { 
    FETCH_AGENT_DASHBOARD_DATA_FAILURE, 
    FETCH_AGENT_DASHBOARD_DATA_PROGRESS, 
    FETCH_AGENT_DASHBOARD_DATA_SUCCESS, 
    FETCH_SINGLE_AGENT_DASHBOARD_DATA_FAILURE, 
    FETCH_SINGLE_AGENT_DASHBOARD_DATA_PROGRESS, 
    FETCH_SINGLE_AGENT_DASHBOARD_DATA_SUCCESS, 
    CLEAR_AGENT_DASHBOARD_DATA_STATE 
} from "./aganetDashboard.actions";

export const agentDashboardReducer = (
    state: IAgentDashboardInformationState = defaultAgentDashbaordInfoState,
    action: any
) => {
    switch (action.type) {
        case FETCH_AGENT_DASHBOARD_DATA_PROGRESS: {
            const newState = produce(state, (draftState: IAgentDashboardInformationState) => {
                draftState.list.loading = LoadState.InProgress;
                draftState.list.data = [];
                draftState.list.totalRecords = 0;
            });
            return newState;
        }
        case FETCH_AGENT_DASHBOARD_DATA_SUCCESS: {
            const { data, totalRecords, currentRecords, totalSum } = action.payload;
            const newState = produce(state, (draftState: IAgentDashboardInformationState) => {
                draftState.list.loading = LoadState.Loaded;
                draftState.list.data = data;
                draftState.list.totalRecords = totalRecords;
                draftState.list.currentRecords = currentRecords;
                draftState.list.totalSum = totalSum;
            });
            return newState;
        }
        case FETCH_AGENT_DASHBOARD_DATA_FAILURE: {
            const newState = produce(state, (draftState: IAgentDashboardInformationState) => {
                draftState.list.loading = LoadState.Failed;
                draftState.list.error = action.payload;
            });
            return newState;
        }
        case FETCH_SINGLE_AGENT_DASHBOARD_DATA_PROGRESS: {
            const newState = produce(state, (draftState: IAgentDashboardInformationState) => {
                draftState.agentDashboardData.loading = LoadState.InProgress;
            });
            return newState;
        }
        case FETCH_SINGLE_AGENT_DASHBOARD_DATA_SUCCESS: {
            const newState = produce(state, (draftState: IAgentDashboardInformationState) => {
                draftState.agentDashboardData.loading = LoadState.Loaded;
                draftState.agentDashboardData.data = action.payload;
            });
            return newState;
        }
        case FETCH_SINGLE_AGENT_DASHBOARD_DATA_FAILURE: {
            const newState = produce(state, (draftState: IAgentDashboardInformationState) => {
                draftState.agentDashboardData.loading = LoadState.Failed;
                draftState.agentDashboardData.error = action.payload;
            });
            return newState;
        }
        case CLEAR_AGENT_DASHBOARD_DATA_STATE: {
            return defaultAgentDashbaordInfoState;
        }
        default: {
            return state;
        }
    }
};
